import {
	DocumentReference,
	DocumentSnapshot,
	onSnapshot,
	Query,
	QuerySnapshot,
	SnapshotListenOptions,
} from 'firebase/firestore';
import { Observable } from 'rxjs';

const DEFAULT_OPTIONS: SnapshotListenOptions = {
	includeMetadataChanges: true,
};

function listenDocument<T>(
	ref: DocumentReference<T>,
	options: SnapshotListenOptions,
	subscriber: {
		next: (value: DocumentSnapshot<T>) => void;
		error: (error: unknown) => void;
		complete: () => void;
	},
) {
	return onSnapshot(ref, options, {
		next: subscriber.next.bind(subscriber),
		error: subscriber.error.bind(subscriber),
		complete: subscriber.complete.bind(subscriber),
	});
}

function listenQuery<T>(
	ref: Query<T>,
	options: SnapshotListenOptions,
	subscriber: {
		next: (value: QuerySnapshot<T>) => void;
		error: (error: unknown) => void;
		complete: () => void;
	},
) {
	return onSnapshot(ref, options, {
		next: subscriber.next.bind(subscriber),
		error: subscriber.error.bind(subscriber),
		complete: subscriber.complete.bind(subscriber),
	});
}

export function fromRef<T>(
	ref: DocumentReference<T>,
	options?: SnapshotListenOptions,
): Observable<DocumentSnapshot<T>>;
export function fromRef<T>(
	ref: Query<T>,
	options?: SnapshotListenOptions,
): Observable<QuerySnapshot<T>>;
export function fromRef<T>(
	ref: DocumentReference<T> | Query<T>,
	options: SnapshotListenOptions = DEFAULT_OPTIONS,
): Observable<DocumentSnapshot<T> | QuerySnapshot<T>> {
	return new Observable((subscriber) => {
		const unsubscribe =
			ref.type === 'document'
				? listenDocument(
						ref as DocumentReference<T>,
						options,
						subscriber,
					)
				: listenQuery(ref as Query<T>, options, subscriber);

		return { unsubscribe };
	});
}
